import { gql } from "@apollo/client";

const EXCHANGE_FACEBOOK_TOKEN = gql`
  mutation ExchangeFacebookToken($shortLivedToken: String!, $userId: String!) {
    exchangeFacebookToken(shortLivedToken: $shortLivedToken, userId: $userId) {
      success
      error
      longLivedToken
      expiresIn
    }
  }
`;

export default EXCHANGE_FACEBOOK_TOKEN;
